// extracted by mini-css-extract-plugin
module.exports = {"newsletterHome":"HomeNewsletter_newsletterHome__urmuM","data":"HomeNewsletter_data__Rf_Qf","title":"HomeNewsletter_title__qpqzv","text":"HomeNewsletter_text__zhCMU"};